import axios from "axios";
import { gzip } from "pako";

const ONE_MB = 1000000;

export const buildCompressRequestTransformer = () => {
  const defaultTransformRequest = Array.isArray(axios.defaults.transformRequest)
    ? axios.defaults.transformRequest
    : [];

  return defaultTransformRequest.concat((data, headers) => {
    if (typeof data === "string" && data.length > ONE_MB) {
      headers["Content-Encoding"] = "gzip";
      return gzip(data);
    } else {
      headers["Content-Encoding"] = undefined;
      return data;
    }
  });
};
